export default __webpack_public_path__ + "static/media/le_croise13.57165af1.jpg";